export enum Eye {
  LEFT,
  RIGHT,
}

export const KEY_TO_DELETE = "PERMANENTLY DELETE";
export const MAX_UPLOAD_FILE_SIZE = 10e6;
export const mobileNumberPrefix = "+852";
